<template>
  <section class="section-pos-pickup-fnb fullscreen">
    <div class="pos-pickup-fnb-content">
      <header>Pick Up Food and Beverages Options</header>
      <button class="btn-modal-close" @click="callClose()">&times;</button>

      <div v-if="show">
        <div class="col-lg-6 col-xl-4 mx-auto text-center pt-5 mt-5">
          <div class="input-fnb-order mb-4">
            <!-- <input v-model="order_code" id="fnbpickup" type="text" /> -->
            <b-form-input
              v-debounce:500="onSearchOrder"
              v-model="searchValue"
              placeholder="Search Order Code, Email, Name, Mobile."
              class=""
              type="search"
              v-on:search="onSearchOrder"
              name="searchFnbOrders"
              id="searchFnbOrders"
              ref="searchFnbOrders"
              tabindex="0"
            ></b-form-input>
            <!-- <label>{{ $t("order") }} {{ $t("code") }}</label> -->
             <VkeyboardFloat
            :ID="'searchFnbOrders'"
            :onClickFun="() => {
              showVKeyboard = !showVKeyboard
            }"
          />
          <Vkeyboard
            :inputName="'searchFnbOrders'"
            :showOrHide="showVKeyboard"
            :initialValue="searchValue"
            @onChangeEvent="() => {}"
            @onKeyEnter="onSearchOrder"
            @changeKeyboardInput="searchValue = $event"
            @onClickClose="() => {
              showVKeyboard = false;
            }"
          />
          </div>
          <!-- <button class="btn-blue-lg" v-on:click="onSearchOrder()">
            {{ $t("submit") }}
          </button> -->
        </div>
          <div class="col-8 mt-5 mx-auto" v-if="searchValue">
        <table class="list-view-table mx-auto tableWidth" style="box-shadow: 0px 1px 5px -1px;" v-if="searchResults.length > 0">
          <thead>
            <tr class="bg-light">
             <th class="w-cell">Order Code</th>
              <th>Customer Details</th>
              <th class="w-cell"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(order, orderIndex) in searchResults"
              :key="orderIndex"
            >
              <td class="font-weight-bold">
                {{ order.order_code }}
              </td>
              <td class="font-weight-bold">{{ order.cust_mobile ? order.cust_mobile : '-' }}&nbsp;<span v-if="order.first_name">({{order.first_name + (order.last_name  ? ' ' + order.last_name : '' )}})</span></td>
              <td class="text-center">
                <b-button
                  variant="default"
                  class="btn-blue pay-btn"
                  @click="onSelectOrder(order)"
                  >{{ "Select" }}</b-button
                >
              </td>
            </tr>
          </tbody>
        </table>
        <table v-if="loading && searchResults.length == 0" class="list-view-table text-left mx-auto w-50 border" border="1">
          <tbody>
            <tr>
              <td class="text-center" colspan="3">
                <b-spinner
                variant="dark"
                label="Spinning"
                class="translate-spinner"
              ></b-spinner>
                </td>
            </tr>
          </tbody>
        </table>
        <table v-if="!loading && searchResults.length == 0" class="list-view-table text-left mx-auto w-50 border" border="1">
          <tbody>
            <tr>
              <td class="text-center" colspan="3">
                <NoRecords/>
                </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="limit"
        aria-controls="my-table"
        class="my-3"
        v-if="searchResults.length > 0"
      ></b-pagination>
        </div>
      </div>

      <div
        v-if="showdetails"
        class="w-100 mx-auto -sm mt-5"
        style="max-width: 475px"
      >
        <div class="d-flex justify-content-between font-weight-bold">
          <div>{{MainOrderDetails[0].order_code}}</div>
          <div :class="className()">STATUS:: {{MainOrderDetails[0].fat_status}}</div>
          </div>
        <div class="rounded border bg-white shadow p-3">
          <div class="row mx-0 font-weight-semi-bold mb-3">
            <div class="col-6">
              <span>Item</span>
            </div>
            <div class="col-3 text-center">
              <span>Qty</span>
            </div>
            <div class="col-3 text-right">
              <span>Price</span>
            </div>
          </div>

          <div
            :key="itemIndex"
            class="col-12"
            v-for="(item, itemIndex) in SubOrderDetails"
          >
            <div class="row align-items-center py-1">
              <div class="col-6">
                <span>{{ item.fst_item_name }}</span>
              </div>
              <div class="col-3 text-center">
                <span>{{ item.fst_quantity }}</span>
              </div>
              <div class="col-3 text-right">
                <span
                  >{{ MainOrderDetails[0].ft_currency_name }}
                  {{ currFormat(item.fp_total_amount)}}</span
                >
              </div>
            </div>
          </div>

          <hr class="my-2" />

          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-6">
                <span>Sub Total</span>
              </div>
              <div class="col-6 text-right">
                <span class="font-weight-semi-bold"
                  >{{ MainOrderDetails[0].ft_currency_name }} &nbsp;{{
                    currFormat(MainOrderDetails[0].ft_net_amount)
                  }}</span
                >
              </div>
            </div>
          </div>

          <div
            class="col-12"
            v-for="(item, itemIndex) in SubOrderDetails"
            :key="itemIndex"
          >
            <div
              v-for="(tax, taxIndex) in item.additionalTaxes"
              :key="taxIndex"
              class="row"
            >
              <div class="col-6">
                <span>{{ tax.ct_name }}</span>
              </div>
              <div class="col-6 text-right">
                <span
                  >{{ MainOrderDetails[0].ft_currency_name }} &nbsp;{{
                    currFormat(tax.totalTax)
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- OFFER -->
          <div
            v-if="
              MainOrderDetails[0] && MainOrderDetails[0].offer_title != null
            "
            class="col-12 py-2"
          >
            <div class="row">
              <div class="col-4">
                <span class="text-black">{{
                  MainOrderDetails[0].offer_title.offer_title ||
                  MainOrderDetails[0].offer_title.offer_code
                }}</span>
              </div>
              <div class="col-8 text-right">
                <strong
                  >{{ MainOrderDetails[0].ft_currency_name }}&nbsp;{{
                    -currFormat(MainOrderDetails[0].ft_offer_price)
                  }}</strong
                >
              </div>
            </div>
          </div>

          <hr class="my-2" />
          <div class="col-12">
            <div class="row">
              <div class="col-4">
                <strong class="fs-16">Total</strong>
              </div>
              <div class="col-8 text-right">
                <strong class="fs-16"
                  >{{ MainOrderDetails[0].ft_currency_name }}&nbsp;{{
                    currFormat(MainOrderDetails[0].ft_total_amount)
                  }}</strong
                >
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-3">
          <button @click="onPrintHandler" class="btn-outline-blue-lg">
            {{ printText }}
          </button>
          <span class="mx-2"></span>
          <button v-if="ShowPrintReceipt == 'Y'" @click="printreceipt" class="btn-blue-lg">
            Print Receipt
          </button>
          <span class="mx-2"></span>
          <button :class="checkOrderStatus(MainOrderDetails[0]) ? '' : 'disBtn-deliver'" v-if="DELIVER_ITEM_FROM_POS_PICKUP == 'Y'" @click="deliverFnbItem()" class="btn-blue-lg">
            Deliver
          </button>
        </div>
      </div>

      <fnb-sales-receipt
        ref="FNb_SalesReceipt"
        :itemsList="itemsList"
        :taxes="taxes"
        :taxesTotal="taxesTotal"
        :currency="currency"
      ></fnb-sales-receipt>
    </div>

    <b-modal
      id="confirmDeliverOrder_pickup"
      ref="confirmDeliverOrder_pickup"
      title="Delivery Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="pb-1">
        <p class="text-center  fs-16 mb-2 font-weight-bold">{{ `Do you want to deliver order ${MainOrderDetails.length > 0 && MainOrderDetails[0].order_code} without processing ?` }}</p>
        <div class="d-flex justify-content-end"><span class="text-danger">&#9673; &nbsp;{{'Not Processed'}}</span></div>
        <table class="table tableItem mb-4 mt-1 border text-center" border="1">
        <thead>
            <tr>
            <th scope="col">QTY.</th>
            <th scope="col">ITEMS</th>
            </tr>
        </thead>
        <tbody>
            <tr
            v-for="(item,
            itemIndex) in SubOrderDetails"
            :key="itemIndex"
            >
            <td>{{item.fst_quantity || '-'}}</td>
            <td>{{item.fst_item_name || '-'}}</td>
            </tr>
        </tbody>
        </table>
        <div class="text-center">
        <button class="btn-outline-blue" @click.prevent.stop="$bvModal.hide('confirmDeliverOrder_pickup')">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click="OnFinalSubmit(MainOrderDetails[0])"
        >
          Deliver
        </button>
        </div>
      </div>
    </b-modal>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </section>
</template>

<script>
import FNbSReceipt from "../PosBookingContainer/ReceiptTemplates/fnb_sales_receipts";
import PosFnbService from "@/services/PosFnbService";
import KitchenService from "@/services/KitchenService";
import { EventBus } from "@/main";
import Printd from "printd";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { Role, CLIENT_NAME } from "@/helper/Role";
import { BASEURL } from "@/config/index";

export default {
  components: {
    // "onecopy-template": OCTemplate,
    // "threecopy-template": ThreeCTemplate,
    // "default-template": DefaultTemplate,
    "fnb-sales-receipt": FNbSReceipt,
    Vkeyboard,
    VkeyboardFloat,
    NoRecords
  },
  data() {
    return {
      searchResults: [],
      searchValue: "",
      showVKeyboard: false,
      phoneError: null,
      phonenumber: null,
      order_code: "",
      MainOrderDetails: [],
      SubOrderDetails: [],
      show: true,
      showdetails: false,
      user_id: null,
      limit: 5,
      currentPage: 1,
      rows: 0,
      loading: false,
      EjsData: null,
    };
  },
  props: {
    printText: {
      type: String,
      default: "Print",
    },
    onClickHandler: {
      type: Function,
    },
    itemsList: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: "",
    },
    subTotal: {
      type: Number,
      default: null,
    },
    total: {
      type: Number,
      default: null,
    },
    taxes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    taxesTotal: {
      type: Number,
      default: null,
    },
    onNumberSubmit: {
      type: Function,
    },
    onPrintCall: {
      type: Function,
    },
  },

  computed: {
     ShowPrintReceipt() {
      return this.$store.getters.showPrintReceiptBtn;
    },
     DELIVER_ITEM_FROM_POS_PICKUP() {
      return this.$store.getters.DELIVER_ITEM_FROM_POS_PICKUP;
    },
    PickupFnbFlag() {
      return this.$store.getters.PickupFnbFlag;
    },
    offerPrice() {
      return this.$store.getters.getOfferPrice;
    },
    offerApplied() {
      return this.$store.getters.getSelectedOffer;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    Items() {
      return this.itemsList;
    },
    Currency() {
      return this.currency;
    },
    SubTotal() {
      return this.subTotal ? this.subTotal : null;
    },
    Total() {
      return this.subTotal !== null && this.taxesTotal !== null
        ? this.subTotal + this.taxesTotal
        : null;
    },
    Taxes() {
      return this.taxes;
    },
    TaxesTotal() {
      return this.taxesTotal ? this.taxesTotal : null;
    },
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
  },
  mounted() {
    this.user_id = this.secureStore.get("USINFO").user_id;
  },
  methods: {
    className() {
      let className = ''
      if( this.MainOrderDetails[0].fat_status == 'Delivered') {
        className = 'text-success'
      } else if(this.MainOrderDetails[0].fat_status == 'Pending') {
        className = 'text-danger'
      } else if(this.MainOrderDetails[0].fat_status == 'Compelete') {
        className = 'text-success'
      } else if(this.MainOrderDetails[0].fat_status == 'Processing') {
        className = 'text-warning'
      }

      return className;
    },
    checkOrderStatus(order) {
      let status = true;
      if(order.hasOwnProperty('fat_status') && order.fat_status) {
        if(order.fat_status == 'Delivered') {
          status = false
        } else {
          status = true
        }
      }

      return status
    },
    deliverFnbItem() {
      if(this.MainOrderDetails.length > 0) {
        if(this.MainOrderDetails[0].fat_status && this.MainOrderDetails[0].fat_status !== 'Complete') {
         this.$bvModal.show('confirmDeliverOrder_pickup')
        } else {
          this.OnFinalSubmit(this.MainOrderDetails[0])
        }
      } else {
        this.$toasted.show('Something Went Wrong! Please Again Try Later')
      }
    },
     OnFinalSubmit: function (order) {
      let payload = {
        ft_id: order.ft_id,
        fnb_order_status: 'Delivered',
      };
      KitchenService.UpdateOrders(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.OnFetch(order.order_code);
            this.$bvModal.hide('confirmDeliverOrder_pickup')
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectOrder(order) {
      this.order_code = order.order_code
      this.OnFetch(order.order_code);
    },
     onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.onSearchOrder();
      } else {
        this.currentPage = event;
        this.onSearchOrder();
      }
    },
    onSearchOrder() {
      if(this.searchValue) {
      this.loading = true;
      let payload = {
        limit: this.limit,
        currentPage: this.currentPage,
        searchValue: this.searchValue
      }

      PosFnbService.SearchFnbOrder(payload).then((response) => {
        const {data} = response;
        if(data && data.status && data.Records) {
          this.searchResults = data.Records
            if (data.totalRow) {
              this.rows = data.totalRow;
            }
        } else {
          this.$toasted.show(data.message)
        }
      }).catch((err) => {
        console.log('onSearchOrder err', err);
        this.$toasted.show('Something Went Wrong')
      }).finally(() => {
        this.loading = false
      })
      } else {
        // this.$toasted.show('Please Enter Valid Order Code')
      }
    },
    printreceipt: function () {
      //For electron
       let payload = {
          OrderCode: this.MainOrderDetails[0].order_code,
          Type: "Print",
          UserID: this.user_id,
          isReprint: false,
          cinemaId: this.secureStore.get("USINFO").cinema_id
        };
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        // Electron-specific code
        try {
          if (this.$socket) {
             if (CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME) {
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "fnb",
                  ...payload
                });

                setTimeout(() => {
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "fnb-security",
                    ...payload
                  });
                }, 2000);
              } else {
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "fnb",
                  ...payload
                });
              }
            // this.$socket.emit("on_print_Fnb", {
            //   OrderCode: this.MainOrderDetails[0].order_code,
            //   Type: "PrintReceipt",
            //   UserID: this.user_id,
            // });
          }
        } catch (err) {}
      } else {
        // let payload = {
        //   OrderCode: this.MainOrderDetails[0].order_code,
        //   Type: "PrintReceipt",
        //   UserID: this.user_id
        // };
        // PosFnbService.GetFnbOrderEjs(payload).then(response => {
        //   console.log("response :>> ", response);
        // });
        if (CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME) {
            PosFnbService.GetFnbOrderEjs(payload)
              .then(async response => {
                const { data } = response;

                this.EjsData = data;

                this.$nextTick(() => {
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });

                // console.log("response :>> ", response);
              })
              // .then(() => {
              //   PosFnbService.GetFnbOrderSecurityEjs(payload).then(response => {
              //     const data = { response };
              //     this.EjsData = data;

              //     this.$nextTick(() => {
              //       loader.hide();
              //       const p = new Printd();
              //       if (this.$refs.onPrint && this.EjsData != null) {
              //         p.print(this.$refs.onPrint, []);
              //       }
              //     });
              //   });
              // })
              .catch(this._CatchError);
          } else {
             this.$store.dispatch("SendPrintDetails", {
                MainDetails: this.MainOrderDetails,
                SubDetails: this.SubOrderDetails,
              });
              this.$store.dispatch("OFFER_DETAILS_FOR_FNB_PICKUP", {
                MainDetails: this.MainOrderDetails,
              });

              setTimeout(function () {
                EventBus.$emit("printFnbSalesReceipt");
              }, 1500);
          }
      }
    },
    callClose: function () {
      // this.$store.dispatch("ClearPrintDetails", []);
      this.onClickHandler({ name: "PosFnbPickup" });
    },
    clearPhoneNumber: function () {
      this.phonenumber = null;
    },
    onClickNumber: function (num) {
      this.phonenumber
        ? (this.phonenumber += `${num}`)
        : (this.phonenumber = `${num}`);
    },
    inputChange(event) {},
    phonenumberHandler: function (event, input) {
      let phoneReg = /\d{7,12}/;
      if (!this.phonenumber) {
        this.phoneError = "Please Enter Phone Number.";
      } else if (this.phonenumber && !phoneReg.test(this.phonenumber)) {
        this.phoneError =
          "Phone number must be digits and minimum 7 digits allows.";
      } else {
        this.$store.dispatch("onSetAndSendLog", {
          action: `SMS option selected for ticket at number : ${this.phonenumber}`,
          page_name: "FNB booking",
          api_name: window.location.hash,
        });
        this.onNumberSubmit({ phonenumber: this.phonenumber });
      }
      this.phoneError && this.phoneError.length > 0
        ? setTimeout(() => {
            this.phoneError = null;
          }, 1500)
        : "";
    },
    onPrintHandler: function () {
      let payload = {
        OrderCode: this.MainOrderDetails[0].order_code || '',
        Type: "Print",
        UserID: this.user_id,
        isReprint: true,
        fnb_transaction_id: this.MainOrderDetails[0].ft_id,
      };

      //For electron
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        // Electron-specific code
        try {
          if (this.$socket) {
            this.$socket.emit("on_print_ticket", {
              baseurl: BASEURL,
              ttype: "fnb",
              ...payload,
            });
            // this.$socket.emit("on_print_Fnb", {
            //   OrderCode: this.MainOrderDetails[0].order_code,
            //   Type: "Print",
            //   UserID: this.user_id,
            // });
          }
        } catch (err) {}
      } else {
        PosFnbService.GetFnbOrderEjs(payload)
          .then(async response => {
            const { data } = response;

            this.EjsData = data;

            this.$nextTick(() => {
              const p = new Printd();
              if (this.$refs.onPrint && this.EjsData != null) {
                p.print(this.$refs.onPrint, []);
              }
            });
          })
          .catch(err => {
            console.log("Error:", err);
          });

        // this.$store.dispatch("SendPrintDetails", {
        //   MainDetails: this.MainOrderDetails,
        //   SubDetails: this.SubOrderDetails,
        // });
        // this.$store.dispatch("OFFER_DETAILS_FOR_FNB_PICKUP", {
        //   MainDetails: this.MainOrderDetails,
        // });
        // this.onPrintCall({ path: "printCall" });
      }
    },

    OnFetch: function (order_code) {
      if (order_code) {
        let payload = {
          order_code: this.order_code,
          isSearch: true
        };

        PosFnbService.GetFnbOrder(payload).then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.show = false;
              this.showdetails = true;
              this.MainOrderDetails = data.Records;
              this.SubOrderDetails = data.Records2;
            }
          } else {
            this.$toasted.show(data.message);
          }
        });
      } else {
        this.$toasted.show("Please enter Order Code");
      }
    },
  },
};
</script>

<style>
.section-pos-pickup-fnb {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  position: fixed;
  background-color: #fff;
  height: calc(100vh);
}

.section-pos-pickup-fnb header {
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 30px;
}

.section-pos-pickup-fnb .btn-modal-close {
  right: 15px;
  top: 12.5px;
  position: absolute;
}

.pos-pickup-fnb-content {
  padding: 15px;
  overflow-y: auto;
  position: relative;
  overflow-x: hidden;
  max-height: calc(100vh - 80px);
}

.section-pos-pickup-fnb .fullscreen {
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  height: 100%;
  padding: 16px;
  position: fixed;
  background-color: #fff;
  overflow-y: auto;
}

input#searchFnbOrders::placeholder {
    font-style: italic;
    font-size: 13px;
}

.input-fnb-order input {
  height: 100%;
    width: 100%;
    border: none;
    display: block;
    padding: 0 15px;
    background-color: white;
    min-height: 40px;
    overflow: hidden;
    border-radius: 10px;
    -webkit-transition: 0.3s ease;
    transition: 0.3s ease;
    border: 1px solid #d3d3d3;
}

.tableItem th,  .tableItem td{
    padding: 4px;
}

.tableItem thead tr{
    background: lightgray;
}

.disBtn-deliver {
  opacity: 0.5;
  pointer-events: none;
}


.pos-pick-up-fnb .btn-modal-close {
}
/* .pos-fnb-final-ticket-wrapper {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  position: fixed;
  height: calc(100vh - 75px);
  background-color: #fff;
}

.pos-fnb-final-ticket-wrapper .btn-modal-close {
  top: 0px;
  right: 15px;
  position: absolute;
}

.fnb-movie-ticket {
  border-radius: 5px;
  box-shadow: 1px 1px 3px 1px #808080ad;
}

.fnb-movie-table {
  width: 100%;
}

.fnb-mt-cut::before,
.fnb-mt-cut::after {
  content: "";
  width: 25px;
  right: -13px;
  z-index: 22;
  height: 25px;
  display: block;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
}

.fnb-mt-cut::before {
  top: -13px;
  border-bottom: 2px solid grey;
}

.fnb-mt-cut::after {
  bottom: -13px;
  border-top: 2px solid grey;
}

.fnb-movie-table td:nth-child(2) {
  width: 60px;
  text-align: right;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posPickupFnB.vue